export default {
  state: () => ({
    messages: [], // Все сообщения
    messagesUnread: [],
    messagesLoaded: false,
    messages_read: [], // Массив с id всех прочитанных сообщений
  }),
  actions: {
    updateMessages({ commit }, value) {
      commit('UPDATE_MESSAGES', value)
    },
    updateMessagesUnread({ commit }, value) {
      commit('UPDATE_MESSAGES_UNREAD', value)
    },
    updateMessagesLoaded({ commit }, value) {
      commit('UPDATE_MESSAGES_LOADED', value)
    },
    updateMessagesRead({ commit }, value) {
      commit('UPDATE_MESSAGES_READ', value)
    },
  },
  mutations: {
    // UPDATE_MESSAGE(state) { state.messages[data.index][data.key] = data.value },
    UPDATE_MESSAGES(state, value) {
      state.messages = value
    },
    UPDATE_MESSAGES_LOADED(state, value) {
      state.messagesLoaded = value
    },
    APPEND_MESSAGE(state, value) {
      state.messages = [...state.messages, value]
    },
    UPDATE_MESSAGES_READ(state, value) {
      state.messages_read = value
    },
    UPDATE_MESSAGES_UNREAD(state, value) {
      state.messagesUnread = value
    },
    APPEND_MESSAGES_READ(state, value) {
      state.messages_read = [...state.messages_read, value]
    },
    MARK_MESSAGE_AS_READ: (state, message) => {
      message.read = true
      state.messages = [...state.messages.filter((element) => element.id !== message.id), message]
    },
  },
  getters: {
    getMessages: (s) => s.messages,
    getMessagesLoaded: (s) => s.messagesLoaded,
    getMessagesRead: (s) => s.messages_read,
    getMessagesUnread: (s) => s.messagesUnread,
    getMessagesUnreadCounter: (s) => s.messagesUnread.length,
  },
}
